import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import {
  getChooseYourPlanBoostValue,
  getEnterFlowProgressValue,
} from 'utils/ab-test/abTests';
import { getMultistepTestGroup } from 'utils/ab-test/multistep/MultistepV5';
import { getHeaderContent, HeaderState } from 'utils/layout/header';

export function useHeaderContent() {
  const router = useRouter();
  const [headerContent, setHeaderContent] = useState<HeaderState>({
    showDrawCounter: false,
    showUpNext: null,
    showOrderSummary: false,
  });
  const enterFlowProgressVariant = getEnterFlowProgressValue();

  useEffect(() => {
    const testGroup = getMultistepTestGroup() || 'CONTROL';
    const boostTestGroup = getChooseYourPlanBoostValue() || 'CONTROL';
    const content = getHeaderContent(router.asPath, testGroup, boostTestGroup);

    if (
      content.showUpNext != null &&
      enterFlowProgressVariant &&
      enterFlowProgressVariant !== 'CONTROL'
    ) {
      // When we're in an enter flow progress variant 'showUpNext' will be non-null. However, we don't want
      // to show anything on the right side of the nav, since the header logo is centered
      content.showUpNext = ' ';
    }

    setHeaderContent(content);
  }, [router.asPath, enterFlowProgressVariant]);

  return headerContent;
}
